import React from 'react';
import PropTypes from 'prop-types';

import { endSession } from '../../helpers/methods';

import Button from '../../component-library/button';

const Error = ({ isPermissionError = false }) => {
	const titleMessage = () => {
		if (isPermissionError) {
			return (<h1>You don&apos;t have permission to view this</h1>);
		}
		return (
			<h1>
				Oops!
				<br />
				Something went wrong
			</h1>
		);
	};

	const bodyMessage = () => {
		if (isPermissionError) {
			return 'Please contact your system administrator for access.';
		}
		return 'Please refresh the page and try again, if the problem persists please contact your system administrator.';
	};

	return (
		<div className="main-container">
			<div className="content-container">
				<div className="padding-vertical-40">
					{titleMessage()}
					<p className="large-text margin-bottom-32">{bodyMessage()}</p>
					<Button
						type="secondary"
						label="Logout"
						onClick={() => endSession()}
					/>
				</div>
			</div>
		</div>
	);
};
export default Error;

Error.propTypes = {
	isPermissionError: PropTypes.bool,
};
